import(/* webpackMode: "eager" */ "/app/src/app/(app)/(tabs)/discover/page.tsx");
